module.exports = __webpack_public_path__ + "04baf98dff8005b6919948e61b4a247b.png";